import Vue from "vue";

import Vuex from "vuex";

Vue.use(Vuex);
//加上防抖
export default new Vuex.Store({
  state: {
    source: null,
    userInfo: null,
    // 解密后的收件人信息（按订单ID存储）
    decryptedReceiverMap: {},
    // 当前子订单图片（用于快捷下单时传递图片到采购明细）
    currentSubOrderPic: null,
    // 当前子订单标题（用于快捷下单时传递标题到采购明细）
    currentSubOrderTitle: null,
    // 当前子订单商品ID（用于createSalesGoodsMapping接口）
    currentSubOrderProductId: null,
    // 当前子订单销售创建时间（用于预览下单和下单接口）
    currentSubOrderSalesCreated: null,
  },
  mutations: {
    setSource(state, payload) {
      state.source = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    // 存储解密后的收件人信息
    setDecryptedReceiver(state, { salesOrderId, receiverInfo }) {
      Vue.set(state.decryptedReceiverMap, salesOrderId, receiverInfo);
    },
    // 清除指定订单的解密信息
    clearDecryptedReceiver(state, salesOrderId) {
      Vue.delete(state.decryptedReceiverMap, salesOrderId);
    },
    // 清除所有解密信息（退出系统时调用）
    clearAllDecryptedReceiver(state) {
      state.decryptedReceiverMap = {};
    },
    // 设置当前子订单图片
    setCurrentSubOrderPic(state, picUrl) {
      state.currentSubOrderPic = picUrl;
    },
    // 清除当前子订单图片
    clearCurrentSubOrderPic(state) {
      state.currentSubOrderPic = null;
    },
    // 设置当前子订单标题
    setCurrentSubOrderTitle(state, title) {
      state.currentSubOrderTitle = title;
    },
    // 清除当前子订单标题
    clearCurrentSubOrderTitle(state) {
      state.currentSubOrderTitle = null;
    },
    // 设置当前子订单商品ID
    setCurrentSubOrderProductId(state, productId) {
      state.currentSubOrderProductId = productId;
    },
    // 清除当前子订单商品ID
    clearCurrentSubOrderProductId(state) {
      state.currentSubOrderProductId = null;
    },
    // 设置当前子订单销售创建时间
    setCurrentSubOrderSalesCreated(state, salesCreated) {
      state.currentSubOrderSalesCreated = salesCreated;
    },
    // 清除当前子订单销售创建时间
    clearCurrentSubOrderSalesCreated(state) {
      state.currentSubOrderSalesCreated = null;
    },
    // 设置当前子订单Oaid
    setCurrentSubOrderOaid(state, oaid) {
      state.currentSubOrderOaid = oaid;
    },
    // 设置当前子订单销售订单ID
    setCurrentSalesOrderId(state, salesOrderId) {
      state.currentSalesOrderId = salesOrderId;
    },
    // 清除当前子订单销售订单ID
    clearCurrentSalesOrderId(state) {
      state.currentSalesOrderId = null;
    },
    // 设置当前子订单采购店铺号
    setCurrentshopNumber(state, shopNumber) {
      state.currentshopNumber = shopNumber;
    },

    // 清除当前子订单Oaid
    clearCurrentSubOrderOaid(state) {
      state.currentSubOrderOaid = null;
    },
  },
  actions: {
    setSource({ commit }, payload) {
      commit("setSource", payload);
    },
    setDecryptedReceiver({ commit }, payload) {
      commit("setDecryptedReceiver", payload);
    },
    setCurrentSubOrderPic({ commit }, picUrl) {
      commit("setCurrentSubOrderPic", picUrl);
    },
    clearCurrentSubOrderPic({ commit }) {
      commit("clearCurrentSubOrderPic");
    },
    setCurrentSubOrderTitle({ commit }, title) {
      commit("setCurrentSubOrderTitle", title);
    },
    clearCurrentSubOrderTitle({ commit }) {
      commit("clearCurrentSubOrderTitle");
    },
    setCurrentSubOrderProductId({ commit }, productId) {
      commit("setCurrentSubOrderProductId", productId);
    },
    clearCurrentSubOrderProductId({ commit }) {
      commit("clearCurrentSubOrderProductId");
    },
    setCurrentSubOrderSalesCreated({ commit }, salesCreated) {
      commit("setCurrentSubOrderSalesCreated", salesCreated);
    },
    clearCurrentSubOrderSalesCreated({ commit }) {
      commit("clearCurrentSubOrderSalesCreated");
    },
  },
  getters: {
    source: (state) => state.source,
    // 根据订单ID获取解密后的收件人信息
    getDecryptedReceiver: (state) => (salesOrderId) => {
      return state.decryptedReceiverMap[salesOrderId] || null;
    },
    // 获取当前子订单图片
    currentSubOrderPic: (state) => state.currentSubOrderPic,
    // 获取当前子订单标题
    currentSubOrderTitle: (state) => state.currentSubOrderTitle,
    // 获取当前子订单商品ID
    currentSubOrderProductId: (state) => state.currentSubOrderProductId,
    // 获取当前子订单销售创建时间
    currentSubOrderSalesCreated: (state) => state.currentSubOrderSalesCreated,
  },
});

